//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import regionLibs from "utils/regionLibs";
// let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "VillageManageAdd",
  data() {
    const valiMobilePass = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的登录手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {
        companyId: "",
        fullName: "",
        personName: "",
        businessZoneId: "",
        businessPersonId: "",
        shortName: "",
        phone: "",
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        areaId: "",
        areaName: "",
        townId: "",
        townName: "",
        villageId: "",
        villageName: "",
        familyNum: "",
        personNum: "",
        farmArea: "",
      },
      businessZoneList: [],
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [],
      // 选择村集体弹框内搜索数据
      filterForm: {
        company: "",
        legalPerson: "",
        type: 75,
      },
      tableData: [],
      pagination: { page: 1, size: 10, pages: 0 },
      rules: {
        phone: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          { validator: valiMobilePass, trigger: "blur" },
        ],
        personName: {
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur",
        },
        businessZoneId: {
          required: true,
          message: "请选择业务区域",
          trigger: "change",
        },
        businessPersonId: {
          required: true,
          message: "请选择业务负责人",
          trigger: "change",
        },
        provinceId: {
          required: true,
          message: "请选择省市县乡镇",
          trigger: "blur",
        },
        villageId: { required: true, message: "请选择村", trigger: "change" },
        fullName: {
          required: true,
          message: "请输入村集体全称",
          trigger: "blur",
        },
        shortName: {
          required: true,
          message: "请输入村集体简称",
          trigger: "blur",
        },
      },
      dialogVisible: false,
      companyName: "", //村集体名称-从弹框选中时有
      submitFlag: false,
      provinceList: [],
      cityList: [],
      areaList: [],
      countyList: [],
      villageList: [],
    };
  },
  watch: {},
  created() {
    this.getBusinessZoneData();
    this.getSelectedCityOptions(1, "provinceList");
  },
  methods: {
    businessZoneChange(newVal) {
      this.form.businessPersonId = "";
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    //村集体数据查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCompanyList();
    },
    //获取列表数据
    getCompanyList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.common.getCompanyList(params).then((res) => {
        this.tableData = res.data.users;
        if (this.pagination.page == 1) this.pagination.pages = res.data.pages;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.handleFilter();
    },
    //选择村集体
    selVillageCollect(row) {
      this.form.companyId = row.id;
      this.form.phone = row.contact_mobile;
      this.form.personName = row.fullname;
      this.companyName = row.company;
      this.dialogVisible = false;
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getVillageList();
    },
    //提交
    handleSubmit(formName) {
      this.submitFlag = true;
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$http.village
            .addVillage(this.form)
            .then((res) => {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.submitFlag = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.submitFlag = false;
            });
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            console.log(dom);
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "end", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
          }
          this.submitFlag = false;
          return false;
        }
      });
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChange(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.areaId = "";
          this.form.townId = "";
          this.form.villageId = "";
          this.cityList = [];
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.areaId = "";
          this.form.townId = "";
          this.form.villageId = "";
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "cityList";
          break;
        case "countyList":
          this.form.townId = "";
          this.form.villageId = "";
          this.countyList = [];
          this.villageList = [];
          list = "areaList";
          break;
        case "villageList":
          this.form.villageId = "";
          this.villageList = [];
          list = "countyList";
          break;
        case "":
          list = "villageList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @description: 回显省市区的options
     * @Author: yangsibo
     * @Date: 2022-05-09 13:59:44
     * @param {*} provinceId
     * @param {*} cityId
     * @param {*} areaId
     * @param {*} townId
     */
    initOptions(provinceId, cityId, areaId, townId) {
      this.getSelectedCityOptions(provinceId, "cityList", "cityName", cityId);
      this.getSelectedCityOptions(cityId, "areaList", "areaName", areaId);
      this.getSelectedCityOptions(areaId, "countyList", "townName", townId);
      this.getSelectedCityOptions(
        townId,
        "villageList",
        "provinceName",
        provinceId,
        1
      );
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
  },
};
